export const LocationIcon = () => {
  return (
    <svg
      width="20"
      height="26"
      viewBox="0 0 20 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8607 14.6567C16.8607 20.0356 11.3515 23.3493 10.2066 23.9805C10.1432 24.0155 10.0719 24.0339 9.99949 24.0339C9.92706 24.0339 9.85581 24.0155 9.79238 23.9805C8.64664 23.3493 3.13916 20.0356 3.13916 14.6567C3.13916 10.3688 5.71195 7.36719 9.99992 7.36719C14.2879 7.36719 16.8607 10.3688 16.8607 14.6567Z"
        stroke="white"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.56982 14.2273C6.56982 15.137 6.93124 16.0096 7.57456 16.6529C8.21788 17.2962 9.09041 17.6576 10.0002 17.6576C10.91 17.6576 11.7825 17.2962 12.4258 16.6529C13.0692 16.0096 13.4306 15.137 13.4306 14.2273C13.4306 13.3175 13.0692 12.4449 12.4258 11.8016C11.7825 11.1583 10.91 10.7969 10.0002 10.7969C9.09041 10.7969 8.21788 11.1583 7.57456 11.8016C6.93124 12.4449 6.56982 13.3175 6.56982 14.2273V14.2273Z"
        stroke="white"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
